<template>
  <el-button v-if="false" size="medium" type="primary">보고서 생성</el-button>
</template>

<script>
export default {
  name: 'WReportButton',
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/button/ReportButton.vue